/**
 * @name: 身份切换组件
 * @author:  miroku
 * @description: 根据创建与被邀请的身份数据进行渲染，点击时更新全局身份、数据
 **/
import React, { useEffect, useState, MouseEvent } from 'react'
import { Tag, message } from 'antd'
import classNames from 'classnames'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { useRouter } from 'next/router'
import { IconSvg } from '@/components'
import globalStore from '@/globalStore'
import { getGlobalRedirectPath } from '@/utils'
import Dropdown from '@/components/CustomerService/Dropdown'
import styles from './SwitchIdentities.module.less'

enum CreditStatus {
  underCertification, // 认证中
  authenticationSucceeded, // 认证成功
  expirationCertification, // 认证过期
  authenticationFailed, // 认证失败
}

const CREDIT_STATUS_TEXT_MAP: { [key in CreditStatus]: string } = {
  [CreditStatus.underCertification]: 'components:header.t1',
  [CreditStatus.authenticationSucceeded]: 'components:header.t2',
  [CreditStatus.expirationCertification]: 'components:header.t3',
  [CreditStatus.authenticationFailed]: 'components:header.t4',
}

const GO_DETAIL_PAGE_MAP = {
  1: '/certification/corporation/detail', // 公司
  2: '/certification/personal/detail ', // 个人主体
}

const SwitchIdentities = ({ campaignsNewGoBackChange, translateTxt }: any) => {
  const history = useRouter()
  const globalMobx = useLocalObservable(() => globalStore)
  const {
    userInfo,
    corporationList,
    hasCorporation,
    activeCorporationId,
    refreshData,
    updateGlobalStore,
    corporationChangeling,
  } = globalMobx
  const [items, setItems] = useState([])

  // 是否认证成功，creditStatus：0-认证中 1-认证成功 2-认证失败
  const isAllCertSuccess = corporationList.every((f: any) => f.creditStatus === 1)

  useEffect(() => {
    const list = corporationList.map((m: any) => {
      m.icon = m.corporationType === 0 ? 'icon-geren' : 'icon-tuandui'
      m.hasBgClass = true
      return m
    })
    setItems(list)
  }, [corporationList, hasCorporation, isAllCertSuccess])

  const changeMenu = (record: any, e: MouseEvent) => {
    // corporationType	认证类型, 0个人账号，1公司，2个人主体
    // 已经选中再次点击
    campaignsNewGoBackChange(() => {
      if (activeCorporationId === record.corporationId) {
        return
      }
      if (corporationChangeling && CreditStatus.authenticationSucceeded === record.creditStatus) {
        message.warning(translateTxt('components:header.t5'))
        return
      }
      switch (record.creditStatus) {
        case 0:
          // 认证中去认证详情
          history.push(GO_DETAIL_PAGE_MAP[record.corporationType])
          break
        case 1:
          updateGlobalStore('corporationChangeling', true)
          // 认证成功，切换账号，刷新页面
          refreshData(record.corporationId, false).then((dataList: any) => {
            if (dataList?.[0]?.code === 0) {
              const globalPath = getGlobalRedirectPath()
              history.pathname !== globalPath && history.push(globalPath)
            }
          })
          break
        case 2:
          // 认证过期，去认证成功详情
          history.push(GO_DETAIL_PAGE_MAP[record.corporationType])
          break
        case 3:
          // 认证失败，去认证详情
          history.push(GO_DETAIL_PAGE_MAP[record.corporationType])
          break
        default:
          break
      }
      e.stopPropagation()
    })
  }

  /**
   * 创建团队
   */
  // const handleCreate = () => {
  //   // 判断有没有绑定手机号，如果没有绑定，引导用户去绑定
  //   if (!userInfo.phone) {
  //     Modal.confirm({
  //       width: 500,
  //       className: styles.confirm,
  //       title: '温馨提示',
  //       content: (
  //         <>
  //           <div>为了确保创建团队的信息完整性，请先【绑定】手机号</div>
  //           {/* <div className="text-center mt-20">
  //       <Button type="primary" onClick={() => history.push('/my/account')}>
  //         前往绑定
  //       </Button>
  //     </div> */}
  //         </>
  //       ),
  //       onOk() {
  //         history.push('/my/account')
  //       },
  //     })
  //     return
  //   }
  //   history.push('/certification/channel')
  // }

  // 非sso用户，且hasCorporation为false，且所有主题都已认证成功
  const showCreateBtn: boolean =
    !userInfo?.isBindSSO &&
    !hasCorporation &&
    isAllCertSuccess &&
    history.pathname !== '/ai/designer'

  return items.length ? (
    <>
      <div className={styles.line} />
      <ul className={styles.menus}>
        {items.map((item: any) => {
          const tk: any = CREDIT_STATUS_TEXT_MAP[item.creditStatus]
          return (
            <li
              key={item.corporationName + item.corporationId}
              className={classNames(
                'flex flex-row items-center cursor-pointer',
                styles.item,
                styles['menu-item'],
                styles[item.className],
              )}
              onClick={e => changeMenu(item, e)}
            >
              <span className={styles.spanWrapper}>
                <IconSvg
                  className={classNames(styles.svg, {
                    [styles['background-icon']]: item.hasBgClass,
                  })}
                  type={item.icon}
                />
                <span className={styles.corporationNameWrap}>
                  <span className={styles.corporationName}>{item.corporationName}</span>
                </span>
              </span>
              {item.creditStatus > -1 &&
                item.creditStatus !== CreditStatus.authenticationSucceeded && (
                  <Tag
                    color="#2171FE"
                    className={classNames(
                      styles.creditTag,
                      styles[CreditStatus[item.creditStatus]],
                    )}
                  >
                    {tk ? translateTxt(tk) : ''}
                  </Tag>
                )}
              {activeCorporationId === item.corporationId && (
                <IconSvg className={classNames(styles.activeIcon)} type="icon-xuanzhong1" />
              )}
            </li>
          )
        })}
        {showCreateBtn && (
          <Dropdown placement="left" translateTxt={translateTxt}>
            <li
              className={classNames(
                'flex flex-row items-center cursor-pointer',
                styles.item,
                styles['menu-item'],
                styles.xinjian,
              )}
              // onClick={handleCreate}
            >
              <span className={styles.spanWrapper}>
                <IconSvg className={styles.svg} type="icon-xinjian" />
                <span className={styles.corporationNameWrap}>
                  <span className={styles.corporationName}>
                    {translateTxt('components:header.t6')}
                  </span>
                </span>
              </span>
            </li>
          </Dropdown>
        )}
      </ul>
    </>
  ) : null
}
export default observer(SwitchIdentities)
